import styled from 'styled-components'

import { premiumFontCss } from '@blade/ui-theme'

export { boostersFontCss, premiumFontCss } from '@blade/ui-theme'

export const PremiumText = styled.span`
  ${premiumFontCss}
`
